import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getEntity = async () => {
  const { data } = await axios.get(`${api_base_url}/Entity`);
  //const { data } = await axios.get("https://localhost:44399/api/Entity");
  return data;
};

export const getDistinctEntity = async () => {
  const { data } = await axios.get(`${api_base_url}/Entity/DistinctEntity`);
  //const { data } = await axios.get("https://localhost:44399/api/Entity");
  return data;
};

export const searchEntity = async (searchInputsData) => {
  var search = searchInputsData.Search;
  return await axios
    .post(`${api_base_url}/Entity/SearchEntity/${search}`)
    .then((res) => res.data);
};

export const getEntityPerState = async (selectedStates) => {
  return await axios
    .post(`${api_base_url}/Entity/EntityPerState`, selectedStates)
    .then((res) => res.data);
};

//Insert New Entity
export const addEntity = async (addEntityData) => {
  const data = await axios.post(`${api_base_url}/Entity`, {
    ...addEntityData,
  });
  return data;
};
//Insert New Entity
// export const addEntity = async (newEntity) => {
//   const newEntityData = {};
//   const { data } = await axios.post(`${api_base_url}/Entity`, newEntityData);
//   return data;
// };
// Update Entity
export const updateEntity = async (entityId, updatedEntity) => {
  return await axios.put(
    `${api_base_url}/Entity/${entityId}`,
    ...updatedEntity
  );
};

//Delete Entity by Id
export const deleteEntity = async (EntityId) => {
  await axios.delete(`${api_base_url}/Entity/${EntityId}`);
};
//

export const bulkDeleteEntity = async (ids) => {
  await axios.delete(`${api_base_url}/Entity/bulkDelete`, {
    data: ids,
  });
};

//Export Entity data
export const exportEntities = async (entitiesId, filterStatus) => {
  var response = await axios.post(
    `${api_base_url}/Entity/ExportExcel/${filterStatus}`,
    entitiesId,
    {
      headers: { "Content-Type": "application/json" },
      responseType: "blob",
    }
  );
  return response;
};

export const downloadEntityTemplate = async () => {
  var response = await axios.get(`${api_base_url}/Entity/download/template`, {
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
  });
  return response;
};

export const validateMassUpload = (data) => {
  return axios.post(`${api_base_url}/Entity/validate`, data).then((res) => {
    return res.data;
  });
};

export const massUploadEntities = (data) => {
  const updatedData = data.map((d) => {
    return { ...d, expirationDate: d.expirationDate.substring(0, 10) };
  });
  return axios
    .post(`${api_base_url}/Entity/massUpload`, updatedData)
    .then((res) => {
      return res;
    });
};
